import headerNav from "./headerNav.vue"
export default headerNav



// WEBPACK FOOTER //
// ./src/layout/headerNav/index.js